import { useEffect, useState } from "react";
import { fetchAgentKnowledge } from "util/agentKnowledgeApi";

const GENERAL_TOPIC = "Genel";
let cached = null;
let pending = null;

// The topics of the company knowledge base, for a voice question's topic picker. Loaded once
// per page; a topic typed on a question that has no record yet is still accepted.
export default function useKnowledgeTopics(enabled = true) {
  const [topics, setTopics] = useState(cached || [GENERAL_TOPIC]);

  useEffect(() => {
    if (!enabled || cached) return undefined;
    let alive = true;
    pending =
      pending ||
      fetchAgentKnowledge().then((res) => {
        cached = Array.isArray(res?.topics) && res.topics.length ? res.topics : [GENERAL_TOPIC];
        return cached;
      });
    pending.then((list) => alive && setTopics(list)).catch(() => {});
    return () => {
      alive = false;
    };
  }, [enabled]);

  return topics;
}

// Called after the knowledge base changes, so the next picker shows new topics.
export function forgetKnowledgeTopics(topics) {
  cached = topics || null;
  pending = null;
}
